import TimeoutIcon from 'assets/ver2/icons/time-expired-icon.svg';
import withAddPaytoAccountsAgreement from 'features/to/HOCs/payment/withAddPaytoAccountsAgreement';
import withPaymentMethodAutoSelect from 'features/to/HOCs/payment/withPaymentMethodAutoSelect';
import withPaytoAgreementProcessing from 'features/to/HOCs/payment/withPaytoAgreementProcessing';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import React from 'react';
import { functionUtils } from 'utils';
import Popup from './popup';

const AuthorisePaytoAccountTimeoutPopup = withPaymentMethodAutoSelect(
  withAddPaytoAccountsAgreement(withPaytoAgreementProcessing(Popup))
);

const AuthorisePaytoAccountTimeoutModal = ({
  isShow,
  action,
  modalOptions,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const { resetPaytoAgreementEditing } = usePaytoStore();

  const { isEdit } = modalOptions || {};

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    resetPaytoAgreementEditing();
    closePortalModalName();
  };

  return (
    <AuthorisePaytoAccountTimeoutPopup
      isOpen={isShow}
      imageSrc={TimeoutIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
        objectFit: 'cover',
      }}
      alignContent="left"
      text={
        isEdit
          ? t('form_update_payto_account_timeout_title')
          : t('form_add_payto_account_timeout_title')
      }
      content={
        isEdit
          ? t('form_update_payto_account_timeout_desc')
          : t('form_add_payto_account_timeout_desc')
      }
      buttonLabel2={t('button_close')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      isPaymentMethodAutoSelectManual
    />
  );
};

export default AuthorisePaytoAccountTimeoutModal;
